import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export type Method = {
  customerUUID: string;
  guid: string;
};

export default (makeCall: MakeCall) =>
  (userId: number, data: { methods: Method[] }) =>
    makeCall<{ status: number }>('PATCH', `/user/${userId}/payout-methods`, {
      data,
    });
